exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_modal_1n4PH {\n  position: relative;\n  width: 80vw;\n  background-size: 100% 100%;\n}\n\n.index_modal_1n4PH .index_closeBtn_21Ozc {\n  position: absolute;\n  right: 0;\n  top: 0.75rem;\n}\n\n.index_modal_1n4PH .index_closeBtn_21Ozc > img {\n  width: 1.5625rem;\n  height: 1.5625rem;\n}\n", ""]);

// Exports
exports.locals = {
	"modal": "index_modal_1n4PH",
	"closeBtn": "index_closeBtn_21Ozc"
};